// components/ClientsView.jsx
import React, { useEffect } from "react";
import { Layout, Space, Table } from "antd";
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllClients } from "../../api/clientsApi";
import { selectAllClients, selectClientId } from "../../store/slices/clients.slice";
import {useClients} from "./useClients";
import { Eye, Route } from 'lucide-react';
import NavTrail from "../../layouts/NavTrail";

const ClientsView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clients = useSelector(selectAllClients);
  const { status, error } = useSelector((state) => state.clients);
  const { switchClient } = useClients();

  useEffect(() => {
    dispatch(fetchAllClients());
  }, [dispatch]);

  const handleCreateClient = () => {
    navigate("/clients/create");
  };

  // Navigate to /clients/view/:clientId
  const handleViewClient = (clientId) => {
    navigate(`/clients/view/${clientId}`);
  };

  const handleCreateClientPath = (clientId)=>{
    switchClient(clientId);
    navigate('/portfolios/paths')
  }

  // Prepare columns for the table
  const columns = [
    {
      title: "Name",
      dataIndex: ["client_details", "name"],
      key: "name"
    },
    {
      title: "Email",
      dataIndex: ["client_details", "email"],
      key: "email"
    },
    {
      title: "Phone",
      dataIndex: ["client_details", "phone"],
      key: "phone"
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const clientId = record.client_id;
        return (
            <Space>
              <Button onClick={handleViewClient} startIcon={<Eye size={18}/>}>
                <span className={'text-xs'}>View</span>
              </Button>
              <Button onClick={handleCreateClientPath} startIcon={<Route size={18}/>}>
                <span className={'text-xs'}>New Path</span>
              </Button>
            </Space>
        );
      }
    }
  ];

  if (status === "loading") return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  const trailItems = [
    { to: '/clients', label: 'Clients' }

  ]

  return (
    <Layout>
      <NavTrail items={trailItems}/>
      <Layout.Content className={'p-12'}>
        <Button variant="outlined" className={'pill'} onClick={handleCreateClient}>
          Create New Client
        </Button>
        <Table
          rowKey="client_id"
          dataSource={clients}
          columns={columns}
          style={{ marginTop: 16 }}
        />
      </Layout.Content>
    </Layout>
  );
};

export default ClientsView;
